<template>
  <La3 :ratio="'426px 1fr 563px'" :styleLeft="{
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '20px 20px 20px 23px',
    gap: '14px'
  }"  :styleCenter="{
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '14px 32px 55px 32px',
    gap: '14px',
    position: 'relative'
  }"  :styleRight="{
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '27px 15px 5px 32px',
    gap: '16px',
    position: 'relative'
  }">
    <template slot="left">
      <div :style="{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
      }">
        <Select :defaultValue="type" @input="type=$event" :width="'170px'">
          <option :value="null">所有商品</option>
          <option v-for="t in typesp" :key="t" :value="t">{{t}}</option>
        </Select>
        <Select :defaultValue="usage" @input="usage=$event" :width="'192px'">
          <option :value="null">商品用途</option>
          <option v-for="t in usages" :key="t" :value="t">{{t}}</option>
        </Select>
      </div>
      <div :style="{width: '100%'}"><SearchInput  :defaultValue="searchText" @input="searchText=$event" :width="'100%'"/></div>
      <div :style="{width: '100%', display: 'flex', gap: '15px'}">
        <button class="pushAll" @click="defaultItems.push(...prods.map(e => { return { item: e, priceDiff: 0, selectable: true } }))">全部加入(不須加價)</button>
        <button class="pushAll" @click="items.push(...prods.map(e => { return { item: e, priceDiff: 0, selectable: true } }))">全部加入(須加價)</button>
      </div>
      <div :style="{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '10px',
        overflowY: 'auto',
        padding: '5px'

      }">
        <div draggable @dragstart="startDrag($event, prod._id)" v-for="(prod, p) in prods" :key="`prod-${p}`" class="prod">
          <div :style="{textAlign: 'start'}">{{prod.name}}</div>
          <div>${{prod.price}}</div>
        </div>
      </div>
    </template>
    <template slot="center">
      <div class="len2" :style="{height: 'fit-content'}">
          <div :style="{display: 'flex', alignItems:'center', justifyContent:'space-between'}">
            <div>選項 (不須加價可換購)</div>
            <button class="clear" @click="defaultItems=[]">清空</button>
          </div>
          <Draggable tag="div" class="items-body" v-model="defaultItems">
            <div v-for="(itmItem, j) in defaultItems" :key="`mulit-${i}-${j}`" class="mulit">
              <div :style="{display: 'flex', alignItems:'center'}">{{itmItem.item.name}} <div :style="{marginLeft: 'auto'}">${{itmItem.item.price}}</div></div>
              <div v-if="j===0" class="default" :style="{marginLeft: 'auto'}">預設</div>
              <template v-else>
                <div class="priceDiff"></div>
                <switchboxsVue :title="'可選'" :defaultValue="defaultItems[j].selectable" @update="defaultItems[j].selectable=$event"/>
              </template>
              <DelBtn @click="defaultItems.splice(j, 1)"/>
            </div>
          </Draggable>
          <div  class="drop"
          @drop="onDrop($event, 'single', i);changeBG(false, i+1)" :ref="`drop-${i+1}`"
          @dragenter="changeBG(true, i+1)"
          @dragleave="changeBG(false, i+1)"
          @dragover.prevent
          @dragenter.prevent></div>
        </div>
      <div class="len2">
          <div :style="{display: 'flex', alignItems:'center', justifyContent:'space-between'}">
            <div>選項 (加價換購)</div>
            <button class="clear" @click="items=[]">清空</button>
          </div>
          <Draggable tag="div" class="items-body" v-model="items">
            <div v-for="(itmItem, j) in items" :key="`mulit-${i}-${j}`" class="mulit">
              <div :style="{display: 'flex', alignItems:'center'}">{{itmItem.item.name}} <div :style="{marginLeft: 'auto'}">${{itmItem.item.price}}</div></div>
              <template>
                <div class="priceDiff" v-if="item.auto==='自動'">可加價 <span :style="{color:'var(--highlight)', fontWeight: 700}">{{itmItem.item.price - (defaultItems[0]?.item.price || 0) }}</span> 元，換購</div>
                <div class="priceDiff" v-else-if="item.auto==='差價'">可加價 <span :style="{color:'var(--highlight)', fontWeight: 700}">{{(itmItem.item.price - item.priceDefault) > 0 ? itmItem.item.price - item.priceDefault : 0}}</span> 元，換購</div>
                <div v-else class="priceDiff" :style="{marginLeft: 'auto'}">可加價 <input type="text" v-model="itmItem.priceDiff"> 元，換購</div>
                <switchboxsVue :title="'可選'" :defaultValue="items[j].selectable" @update="items[j].selectable=$event"/>
              </template>
              <DelBtn @click="items.splice(j, 1)"/>
            </div>
          </Draggable>
          <div  class="drop"
          @drop="onDrop($event, 'multi', i);changeBG(false, i+1)" :ref="`drop-${i+1}`"
          @dragenter="changeBG(true, i+1)"
          @dragleave="changeBG(false, i+1)"
          @dragover.prevent
          @dragenter.prevent></div>
        </div>
    </template>
    <div class="setfields" id="settingsets">
        <div :style="{width: '100%'}" class="field" label="*自動價差" ><RT :options="['自動', '差價', '客製']" :defaultValue="item.auto" @input="item.auto=$event"/></div>
        <div :style="{width: '100%'}" class="field" label="*差價金額"  v-if="item.auto==='差價'"><input type="text" v-model="item.priceDefault"></div>
        <div :style="{width: '100%'}" class="field" label="*群組名稱" ref="name"><textarea v-model="item.name" :style="{height: '3em'}"/></div>
        <BtnsS :style="{marginTop: '30px'}" @save="save" @cancel="$router.push({ name: $route.name, query: { page: '商品群組' } })"/>
        <div class="note">
          <div>*自動: 換購需補價差為"與預設項目差值"。</div>
          <div>*差價: 換購需補價差為"與"差價"差值"。</div>
          <div>*客製: 換購需補價差為"手動填入金額"。</div>
        </div>
    </div>
  </La3>
</template>

<script>
import switchboxsVue from '../../../components/radio/switch.vue'
import DelBtn from '../../../components/btn/del.vue'
import Draggable from 'vuedraggable'
import Select from '../../../components/select.vue'
import La3 from '../../../components/layout/La3.vue'
import SearchInput from '../../../components/input/search.vue'
import { getapi, postapi } from '../../../store/fetch'
import { mapState } from 'vuex'
export default {
  props: ['types', 'typesp'],
  components: { La3, SearchInput, Select, Draggable, DelBtn, switchboxsVue },
  data () {
    return {
      usage: null,
      type: null,
      searchText: null,
      prods: [],
      defaultItems: [],
      items: [],
      item: {
        name: null,
        auto: '自動',
        priceDefault: 0
      }
    }
  },
  async mounted () {
    await this.getprods()
  },
  computed: {
    id () {
      return this.$route.query.id
    },
    ...mapState({
      usages: 'usages'
    })
  },
  watch: {
    id: {
      async handler () {
        const { name, auto, priceDefault, items, defaultItems } = await getapi(`options/group/edit/${this.id}`)
        this.item = { name, auto, priceDefault }
        this.items = items
        this.defaultItems = defaultItems
      },
      immediate: true
    },
    searchText () { this.getprods() },
    type () { this.getprods() },
    usage () { this.getprods() }
  },
  methods: {
    async save () {
      const { name, auto, priceDefault } = this.item
      const params = { name, auto, priceDefault, defaultItems: this.defaultItems, items: this.items }
      const r = await postapi(`options/group/${this.id}`, params)
      if (r) {
        this.$router.push({ name: this.$route.name, query: { page: '商品群組' } })
      }
    },
    changeBG (bo, index) {
      const ref = this.$refs[`drop-${index}`][0] || this.$refs[`drop-${index}`]
      console.log('changeBG', bo, index, `drop-${index}`, ref)
      if (bo) {
        ref.classList.add('in')
      } else {
        ref.classList.remove('in')
      }
    },
    startDrag (event, item) {
      console.log('startDrag', item)
      event.dataTransfer.dropEffect = 'move'
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.setData('itemID', item)
    },
    onDrop (event, mode, listIndex) {
      const itemID = event.dataTransfer.getData('itemID')
      const item = this.prods.find(it => it._id === itemID)
      if (mode === 'single') {
        this.defaultItems.push({ item, priceDiff: 0, selectable: true })
      } else if (mode === 'multi') {
        this.items.push({ item, priceDiff: 0, selectable: true })
      }
    },
    async getprods () {
      const params = {}
      if (this.type) params.category = this.type
      if (this.usage) params.type = this.usage
      if (this.searchText) params.searchText = this.searchText
      this.prods = await getapi('rest_product/single?' + new URLSearchParams(params))
    }
  }

}
</script>

<style lang="scss" scoped>
.clear {
  width: fit-content;
  padding: 5px 10px;
  letter-spacing: 2px;
  border-radius: 3px;
  background-color: #B9B9B9;
  color: #FFFFFF;
}
.pushAll {
  width: 100%;
  min-height: 40px;
  background-color: var(--color-checked);
  color: #FFFFFF;
  border-radius: 3px;
  letter-spacing: 1px;
  font-size: 18px;
}
.note {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #787878;
}
.setfields {
  overflow-y: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-right: 20px;
  height: fill;
  padding-bottom: 40px;
}
.default {
  font-weight: 400;
  font-size: 16px;
  line-height: 180%;
  color: #FFFFFF;
  width: 70px;
  height: 30px;
  background: #9DC56E;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.single, .mulit {
  display: flex;
  min-height: 40px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.1em;
  color: #787878;
  &>div:nth-child(1) {
    display: inline;
    min-width: 300px;
    text-align: start;
    white-space: nowrap;
  }
  .priceDiff {
    width: 200px;
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    letter-spacing: 0.05em;
    color: var(--color-pri);
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    align-items: center;
    gap: 8px;
    span {
      display: inline;
      width: 3em;
    }
    input {
      font-weight: 500;
      font-size: 18px;
      line-height: 180%;
      letter-spacing: 0.1em;
      color: #FF7373;
      text-align: center;
      width: 70px;
      height: 40px;
      border: 1px solid #C4C4C4;
      border-radius: 3px;
    }
  }
}
.items-body {
  padding-block: 14px 0;
  gap: 9px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-inline: 20px;
  overflow-y: auto;
}

.len2 {
  border: 2px solid var(--color-pri);
  width: 100%;
  border-radius: 10px;
  height: -webkit-fill-available;
  display: flex;
  flex-direction: column;
  &>div:nth-child(1) {
    height: 55px;
     width: 100%;
     border-bottom: 1px solid var(--color-pri);
     display: flex;
     align-items: flex-end;
     justify-content: flex-start;
     padding-block: 16px 11px;
     gap: 15px;
     &>div:nth-child(1) {
      font-weight: 500;
      font-size: 20px;
      line-height: 28px;
      letter-spacing: 0.1em;
      color: var(--color-pri);
     }
     &>div:nth-child(2) {
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      letter-spacing: 0.1em;
      color: #959595;
      vertical-align: text-bottom;
      flex: 1;
     }
  }
}
.len2>:nth-child(1) {
  padding-inline: 19px;
}

.drop {
  min-height: 60px;
  height: -webkit-fill-available;
  width: 100%;
  flex: 1;
  &.in {
    background-color: var(--color-bar);
  }
}
.prod {
  width: 100%;
  background-color: var(--color-bar);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-inline: 19px 24px;
  height: 60px;
  min-height: 60px;
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.1em;
  &>div:nth-child(2) {
    margin-left: auto;
  }
  &::after {
    content: '';
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    mask-image: url(/ham.svg);
    background-color: var(--color-pri);
    mask-repeat: no-repeat;
    mask-position: center right;
  }
}
.field {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  &.c {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    &>:nth-child(1) {
      margin-left: 14px;
    }
  }
  &::before {
    margin-right: 15px;
    white-space: nowrap;
    content: attr(label);
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 150%;
    letter-spacing: 0.1em;
    color: var(--color-pri);
  }
  &.highlight::before {
    color: red;
  }
  input[type=checkbox] {
    appearance: none;
    width: 39px;
    height: 20px;
    border-radius: 10px;
    position: relative;
      background-color: #FF8B8B;
    &:checked {
      background-color: #85CA9E;
    }
    &::before {
      content: '';
      display: inline-flex;
      width: 16px;
      height: 16px;
      position: absolute;
      left: 2px;
      right: auto;
      top: 2px;
      background-color: #FFFFFF;
      border-radius: 8px;
    }
    &:checked::before {
      right: 2px;
      left: auto;
    }
    &.invert {
      background-color: #85CA9E;
      &:checked {
        background-color: #FF8B8B;
      }
    }
  }
  textarea {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    margin-top: 14px;
    width: calc(100% - 28px);
    height: 150px;
    border: 1px solid var(--color-border);
    padding: .75em;
    border-radius: 5px;
  }
  input[type=text] {
    width: 6em;
    height: 40px;
    border: 1px solid var(--color-border);
    text-align: center;
    font-size: 20px;
    border-radius: 3px;
  }
}
</style>
